import * as R from 'ramda';
import { _Boolean } from '@/API';
import { TaskArgItem } from '@/appsync/graphql/task';
import {
  TaskMetadataArgItem,
  TaskMetadataItem,
} from '@/appsync/graphql/taskMetadata';
import {
  TaskItemForDB,
  TaskMetadataArgItemForFront,
  TaskMetadataItemForFront,
} from '@/types/type';
import { boolean2_BooleanEnum } from '@/utils/CommonUtils';

export const getEmptyArgs = (taskMetadata: TaskMetadataItemForFront) => {
  const args = taskMetadata.args
    .filter(arg => arg.display)
    .map(arg => {
      return {
        option: arg.option,
        value: arg.default ? arg.default : '',
        order: arg.order,
        replaceInFileName: _Boolean._false,
      };
    });
  return args;
};

export const toTaskMetadataItem = (
  taskMetaDataForFront: TaskMetadataItemForFront
): TaskMetadataItem => {
  const taskMetadataArgs: TaskMetadataArgItem[] = [];
  taskMetaDataForFront.args.forEach(taskMetaDataForFrontArg => {
    const taskMetaDataForFrontArgWithoutValue = R.dissoc('value')(
      taskMetaDataForFrontArg
    ) as TaskMetadataArgItemForFront;
    const {
      display,
      isInputFile,
      isMultiple,
      isOutputFile,
      isSecret,
      isResolvable,
      required,
    } = taskMetaDataForFrontArgWithoutValue;
    const taskMetadataArgItem = {
      ...taskMetaDataForFrontArgWithoutValue,
      display: boolean2_BooleanEnum(display),
      isInputFile: boolean2_BooleanEnum(isInputFile),
      isMultiple: boolean2_BooleanEnum(isMultiple),
      isOutputFile: boolean2_BooleanEnum(isOutputFile),
      isSecret: boolean2_BooleanEnum(isSecret),
      isResolvable: boolean2_BooleanEnum(isResolvable),
      required: boolean2_BooleanEnum(required),
    };

    taskMetadataArgs.push(taskMetadataArgItem);
  });

  const taskMetadataItem: TaskMetadataItem = {
    ...taskMetaDataForFront,
    args: taskMetadataArgs,
  };
  return taskMetadataItem;
};

export const mergeArgsOfTaskMetadataAndTask = (
  taskMetadata: any,
  task: TaskItemForDB
) => {
  const getArgsToDisplay = R.pipe(
    R.prop('args'),
    R.filter<any>(R.propEq('display', true))
  );

  const argsWithValueByOption = R.groupBy(
    (taskArgItem: TaskArgItem) => taskArgItem.option,
    task.args
  );

  const taskMetadataWithOnlyArgsToDisplay: any[] = getArgsToDisplay(
    taskMetadata
  );

  const argsWithValue = R.map(
    arg =>
      R.mergeRight(
        arg,
        argsWithValueByOption[arg.option]
          ? argsWithValueByOption[arg.option][0]
          : {}
      ),
    taskMetadataWithOnlyArgsToDisplay
  );

  const argsWithValueSortedByOrder = R.sortBy(R.prop('order'))(argsWithValue);

  return argsWithValueSortedByOrder;
};

export const sortTaskMetadataListArgsByOrder = R.lift(
  R.over(R.lensPath(['args']), R.sortBy(R.prop('order')))
);
